export default {
  default: {
    name: 'Dashboard',
  },
  bottom: [
    {
      name: 'personal_profile',
      icon: 'user',
      active: true,
      path: 'profile',
    },
    {
      name: 'logout',
      exit: true,
      icon: 'logout',
      active: true,
    },
  ],
  additional: [
    {
      name: 'messages',
      icon: 'message',
      active: true,
      path: 'requests',
    },
  ],
};
